import { GOOGLE_ADDRESS_VALIDATION } from '~~/constants/checkout';
import type { CountryCodeValue } from '~~/types/localization/localizationHelperTypes';

export const isGoogleAddressValidationEnabled = (country: CountryCodeValue): boolean | undefined => {

  return GOOGLE_ADDRESS_VALIDATION[country];

};
